import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Header, Titulo} from '../elementos/Header'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioAutor from './FormularioAutor'
import favicon from '../imagenes/logoutm.png'

const RegistroCultura = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Registro de Autor</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Registro de Autor</Titulo>
                    <BtnRegresar ruta="/autores"/>
            </Header>

            <FormularioAutor />
        </>
    );
}
 
export default RegistroCultura;